import React, { FC } from 'react';
import cx from 'classnames';
import Typo from '../Typography/Typo';
import { PromptSettingsLiveStatus } from '../Prompt/constants';
import { getPromptTooltipLabel } from './utils/getPromptTooltipLabel';

type TextSize = 'small' | 'medium';

const textVariant: Record<TextSize, string> = {
  small: '!text-sm',
  medium: '!text-base md:!text-lg',
};

type TPromptCardStatusLabelTitleProps = {
  status: PromptSettingsLiveStatus;
  textSize?: TextSize;
};

export const PromptCardStatusLabelTitle: FC<TPromptCardStatusLabelTitleProps> = ({ status, textSize = 'small' }) => (
  <Typo
    variant="small-p"
    className={cx('relative font-semibold', textVariant[textSize], {
      'text-t2-success-darkGreen uppercase before:absolute before:top-1/2 before:-left-3 before:-translate-y-1/2 before:w-[9px] before:h-[9px] before:rounded-full before:bg-t2-success-darkGreen':
        status === PromptSettingsLiveStatus.LIVE,
      'text-t2-neutral-grey09 capitalize':
        status === PromptSettingsLiveStatus.UPCOMING || status === PromptSettingsLiveStatus.COMPLETED,
    })}
  >
    {getPromptTooltipLabel(status)}
  </Typo>
);
